<script>
    import AccordionContent from './AccordionContent.svelte'

    export let accordion
</script>
<div class="accordion-container">
    {#each accordion as part}
        <AccordionContent title={part.name}>
            {@html part.content}
        </AccordionContent>
    {/each}
</div>
<style>
.accordion-container{
    margin-top: 30px;
    margin-bottom: 45px;
    display: block;
}
</style>